<template>
  <div>
      <section class="blog-area blog-area3">
        <div class="container">
            <div class="row blog-post-wrapper">
                <div class="col-lg-4 blog-post-item" v-for="(article,index) in articles" :key="index">
                    <div class="blog-post-img">
                        <img v-if="article.picsrc" :src="`${global.remoteIp}/uploads/${article.picsrc}`" :alt="article.title" class="blog__img">
                        <div class="blog__date" v-if="article.addtime">
                            <span>{{article.addtime.slice(0,10)}}</span>
                        </div><!-- end blog__date -->
                    </div><!-- end blog-post-img -->
                    <div class="post-body">
                        <div class="blog-title">
                            <router-link
                                :to="`/views/info/${article.plateid}/${article._id}`"
                                target="_blank"
                                >{{article.title}}</router-link
                                >
                        </div>
                        <ul class="blog__panel d-flex align-items-center">
                            <li><a href="#" class="blog-admin-name">{{article.writer}}</a></li>
                            <li><span class="blog__panel-likes">{{article.artvisits}} 次浏览</span></li>
                        </ul>
                    </div><!-- end post-body -->
                </div><!-- end blog-post-item -->
            </div><!-- end row -->
            <div class="row">
                <div class="col-lg-12">
                    <div class="pagination-wrap">
                        <el-pagination
                            background
                            :page-size="5"
                            :hide-on-single-page="intTotal<=6"
                            layout="prev, pager, next"
                            @current-change="toPage"
                            @prev-click="toPage"
                            @next-click="toPage"
                            :total="intTotal">
                        </el-pagination>
                    </div><!-- end pagination-wrap -->
                </div><!-- end col-lg-12 -->
            </div><!-- end row -->
        </div><!-- end container -->
    </section><!-- end blog-area -->
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  data () {
    return {
        global,
        intTotal:20,
        intCurrent:1,
        articles:[],
        plateId:"",
    };
  },

  components: {},

  computed: {},

  mounted() {
    let plateId = this.$route.params.plateId;
    this.plateId = plateId;
    this.$axios.get(`/api/articles?plateid=${plateId}&page=${this.intCurrent}&limit=6&sort=-createdAt`).then((res) => {
        if (res.data) {
            this.intTotal =res.data.total;
            this.articles = res.data.data;
        }
    });
  },

  methods: {
      toTop(){
        document.body.scrollTop =0;
        document.documentElement.scrollTop = 0;
      },
      toPage(intcount){
         
        this.intCurrent = intcount;
        this.$axios.get(`/api/articles?plateid=${this.plateId}&page=${this.intCurrent}&limit=6&sort=-createdAt`).then((res) => {
            if (res.data) {
                this.intTotal =res.data.total;
                this.articles = res.data.data;
                 this.toTop();
            }
        });
    },
  }
}

</script>
<style scoped>
::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active{
    background-color: #51be78;
}
::v-deep .el-pager li.active{
    color: #51be78;
}
</style>